import { $ } from 'ng'

export default () => ({
    scope: false,
    link(scope, element, attr) {
        element.on('click', e => {
            $(attr.reloadImages).each((i, img) => {
                var $img = $(img);
                var src = $img.attr('src');
                var concatenator = src.indexOf('?') > 0 ? '&' : '?';
                src += `${concatenator}${new Date().getTime()}=no-cache`;
                $img.attr('src', src);
            });
        });
    }
});